import { put, takeEvery } from 'redux-saga/effects'
import { v4 as uuidv4 } from 'uuid'
import { NOTIFICATION_ANIMATION_DURATION } from 'modules/Notifications/constants'
import { REMOVE_AFTER_DELAY, SHOW } from 'modules/Notifications/types'
import {
  notificationAdd,
  notificationRemove,
} from 'modules/Notifications/actions'

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

function* addNotification({ payload }) {
  try {
    const notificationUUID = uuidv4()
    yield put(notificationAdd({ ...payload, UUID: notificationUUID }))
  } catch (error) {
    console.logXHR(error)
  }
}

function* notificationRemoveAfterDelay({ payload }) {
  yield delay(NOTIFICATION_ANIMATION_DURATION)
  yield put(notificationRemove({ UUID: payload.UUID }))
}

export default function* Sagas() {
  yield takeEvery(SHOW, addNotification)
  yield takeEvery(REMOVE_AFTER_DELAY, notificationRemoveAfterDelay)
}
